export default {
    restBaseUrl: '/kubos/rest',
}
